import { useMemo, useState } from 'react';

import { paginationDefaultValues } from './constants.ts';
import type { UsePaginationReturnType } from './types.ts';
import { PaginationDefaultValue } from './types.ts';

export const usePagination = (limit?: PaginationDefaultValue): UsePaginationReturnType => {
  const [page, setPage] = useState<number>(0);
  const [perPage, setPerPage] = useState<number>(
    limit ? paginationDefaultValues[limit] : paginationDefaultValues[PaginationDefaultValue.LG],
  );

  return useMemo<UsePaginationReturnType>(
    () => ({
      page,
      setPage,
      perPage,
      setPerPage,
    }),
    [page, perPage],
  );
};
